<app-view-item *ngIf="disabled" [text]="selected?.code" [tabindex]="tabindex"></app-view-item>
<div class="tax-code-select-container" *ngIf="!readonly">
  <nz-select #selector nzShowSearch nzServerSearch [nzAllowClear]="nzAllowClear" [nzBackdrop]="addBackdrop"
    [nzFilterOption]="nzFilterOption" (nzOnSearch)="onSearch($event)" (nzOpenChange)="onDropdownOpenChange($event)"
    [nzCustomTemplate]="displayTpl" (nzScrollToBottom)="loadMore()" (keydown)="handleKeyDown($event)"
    (click)="handleClick($event)" [(ngModel)]="value" (ngModelChange)="valueChanged($event)"
    [nzBorderless]="borderless"
    [nzDropdownMatchSelectWidth]="false" nzDropdownClassName="dropdownSelect" class="width-100" [nzOptionHeightPx]="32"
    [nzOptionOverflowSize]="6" [nzPlacement]="'bottomLeft'" [tabindex]="tabindex">
    <ng-template #displayTpl let-selected>
      <span nz-tooltip nzTooltipTitle="{{ selected.rate | percent: '1.2-2' }}">
        {{ selected.nzLabel }}
      </span>
    </ng-template>

    <!-- Custom Add New Button at top -->
    <nz-option *aclIf="{ ability: ['wtaxcode.create'], mode: 'allOf' }" [nzValue]="null" [nzLabel]="''" nzCustomContent>
      <ng-container *ngIf="!searching && showAddNewButton && !this.NotShowInReport">
        <div class="text-center">
          <button type="button" nz-button nzType="primary" class="add-new-button" (click)="onAddNewClick($event)">
            <span nz-icon nzType="plus"></span>
            {{ storedInstantData ? ' Add New \''+ storedInstantData +'\'' : ' Add New' }}
          </button>
        </div>
      </ng-container>
    </nz-option>

    <ng-container *ngFor="let o of list">
      <nz-option *ngIf="!searching" [nzValue]="getValue(o)" [nzLabel]="o.code" nzCustomContent>
        <div>
          <div class="text-gray-500">{{ getTaxCategoryLabel(o) }}</div>
          <div>
            <span>{{ o.code }}</span>
            <span>: </span>
            <span class="text-grey-dark">
              {{ o.rate | percent: '1.2-2' }}
            </span>
          </div>
        </div>
      </nz-option>
    </ng-container>
  </nz-select>
</div>
<ng-template #loadingTpl>
  <div *ngIf="searching">
    <nz-spin></nz-spin>
    Loading
  </div>
</ng-template>
